import script from "./BeatPreviewRail.vue?vue&type=script&setup=true&lang=js"
export * from "./BeatPreviewRail.vue?vue&type=script&setup=true&lang=js"

import "./BeatPreviewRail.vue?vue&type=style&index=0&id=152177c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-152177c0"]])

export default __exports__